var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button is-small lock",on:{"click":function($event){return _vm.handleClick()}}},[_vm._v("Neuer Auftrag")])])
}
var staticRenderFns = []

export { render, staticRenderFns }